import TableHeaderCell from './header/table-header-cell.jsx'
import { HeaderTr, TableDndFrame, TableStyled } from '../styled-components.js'
import PropTypes from 'prop-types'

const TableContent = ({
  table,
  rowSelection = null,
  children,
  dndState = null,
  tableRef = null,
  ...props
}) => {
  const { getFlatHeaders, getRowModel } = table

  const emptyTable = getRowModel().rows.length === 0

  const tableElement = (
    <TableStyled style={{ width: '100%' }} {...props}>
      <thead>
        <HeaderTr>
          {getFlatHeaders().map((header) => {
            const isFlexible = header.column.columnDef.meta?.isFlexible
            const minWidth = header.column.columnDef.meta?.minWidth
            return (
              <TableHeaderCell
                key={header.id}
                header={header}
                table={table}
                onClick={header.column.getToggleSortingHandler()}
                width={
                  isFlexible ? '100%' : (header.column.getSize() ?? 'auto')
                }
                minWidth={minWidth}
                disabled={emptyTable}
              />
            )
          })}
        </HeaderTr>
      </thead>

      {children}
    </TableStyled>
  )

  if (!dndState && !tableRef) {
    return tableElement
  }

  return (
    <TableDndFrame
      ref={tableRef}
      $canDrop={dndState?.canDrop}
      $isDroppable={dndState?.isDroppable}
      $isOver={dndState?.isOver}
    >
      {tableElement}
    </TableDndFrame>
  )
}

TableContent.propTypes = {
  table: PropTypes.object.isRequired,
  rowSelection: PropTypes.object,
  children: PropTypes.node.isRequired,
  dndState: PropTypes.shape({
    canDrop: PropTypes.bool,
    isDroppable: PropTypes.bool,
    isOver: PropTypes.bool
  }),
  tableRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
}
export default TableContent
